import {
    /** FETCH APPLICATION  */
    FETCH_APPLICATIONSTART_FULFILLED,
    FETCH_APPLICATIONSTART_REJECTED,
    FETCH_APPLICATIONSTART_PENDING,
    RESET
} from "../../actions/application/startApplication";
const initialState = {
    done: false,
    error: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_APPLICATIONSTART_PENDING:
            return {
                done: false,
                error: {},
            };
        case FETCH_APPLICATIONSTART_FULFILLED:
            localStorage.setItem("applicationId", action.payload.id)
            return {
                ...state,
                applicationStart: action.payload,
                done: true,
            };
        case FETCH_APPLICATIONSTART_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
            };
        case RESET:
            return {
                initialState,
                done: false,
                error: {},
            };
        default:
            return state;
    }
};